export default __webpack_public_path__ + "static/media/6_Meth_Protection_Icon.4ba51ff6.svg";